<template>
    <vx-card  class="mb-base my-2">
        <div class="flex flex-col" style="text-align: center;">
            <h3>{{ $t("register-over")}}</h3>
            <h3>{{ $t("Pleaserefertoyour")}} {{ $t("advisory")}}</h3>
        </div>

        <div class="mt-4">
            <p>{{ this.profileAdvisor.full_name }}</p>
        </div>
        <span style="cursor: pointer;">
            <p style="float: left; margin-right: 5px;">Email:</p>
            <a :href="'mailto:' + profileAdvisor.email" >
                <p>{{ profileAdvisor.email }}</p>
            </a>
        </span>
    </vx-card>
</template>

<script>
export default {
    name: "MassegeAdvizer",
    props:{
        profileAdvisor:Object
    }
};
</script>

<style scoped>

</style>
